/*global jQuery */
;(function ($, window, document, undefined) {
  'use strict';
  var $document,
    $window,
    $nav,
    classOpen = 'is-openNavmainSecond',

    build = function () {

      $document = $(document);

      if (window.matchMedia('(min-width: 1025px)').matches) {
        $document.on('mouseover', '.js-navmain-second-sub-button', function (e) {

          e.preventDefault();
          e.stopPropagation();

          var $this = $(e.currentTarget);
          var $subMenu = $this.parents('.js-navmain-second-sub');

          var $clickedSubMenu = $this.parents('.js-navmain-second-sub');
          var $subMenues = $nav.find('.js-navmain-second-sub');

          $subMenues.each(function () {


            var $this = $(this);
            var $body = $this.find('.js-navmain-second-body');

            if ($this.is($clickedSubMenu)) {

              if ($subMenu.hasClass(classOpen)) {
                // close clicked submenu

                $body.css('height', $body.get(0).scrollHeight).height('');

                $subMenu.removeClass(classOpen);
              } else {
                // open clicked submenu
                $body.css('height', $body.get(0).scrollHeight);
                $body.one('webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionEnd', function (e) {
                  $body.css('height', '');
                });
                $subMenu.addClass(classOpen);

                $document.triggerHandler('navMain/isOpened');
              }

            } else {

              // close all other submenues
              if ($this.hasClass(classOpen)) {
                $body.css('height', $body.get(0).scrollHeight).height('');
                $this.removeClass(classOpen);
              }
            }

          });

        });
      } else {
        $document.on('click', '.js-navmain-second-sub-button', function (e) {

          e.preventDefault();
          e.stopPropagation();

          var $this = $(e.currentTarget);
          var $subMenu = $this.parents('.js-navmain-second-sub');

          var $clickedSubMenu = $this.parents('.js-navmain-second-sub');
          var $subMenues = $nav.find('.js-navmain-second-sub');

          $subMenues.each(function () {


            var $this = $(this);
            var $body = $this.find('.js-navmain-second-body');

            if ($this.is($clickedSubMenu)) {

              if ($subMenu.hasClass(classOpen)) {
                // close clicked submenu

                $body.css('height', $body.get(0).scrollHeight).height('');

                $subMenu.removeClass(classOpen);
              } else {
                // open clicked submenu
                $body.css('height', $body.get(0).scrollHeight);
                $body.one('webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionEnd', function (e) {
                  $body.css('height', '');
                });
                $subMenu.addClass(classOpen);

                $document.triggerHandler('navMain/isOpened');
              }

            } else {

              // close all other submenues
              if ($this.hasClass(classOpen)) {
                $body.css('height', $body.get(0).scrollHeight).height('');
                $this.removeClass(classOpen);
              }
            }

          });

        });
      }
      // close on outer click
      $document.on('click', function (e) {
        if ($('.is-openNavmainSecond').length) {
          closeAll();
        }
      });
    },
    closeAll = function () {
      var $subMenues = $('.js-navmain-second-sub');

      $subMenues.each(function () {
        var $this = $(this);
        var $body = $this.find('.js-navmain-second-body');

        if ($this.hasClass(classOpen)) {
          $body.css('height', $body.get(0).scrollHeight).height('');
          $this.removeClass(classOpen);
        }
      });
    },
    init = function () {
      $window = $(window);
      $document = $(document);
      $nav = $('.js-navmain');

      if ($nav.length) {
        build();
      }

    };
  init();


})(jQuery, window, document);
